const data = {
    "年度专辑": [
        {
            "作品名称": "猎户星座",
            "表演者": "朴树",
            "出品方": "不晚音乐/地球娱乐",
            "制作人": "朴树、张亚东",
            "实体发行方": "经典五大(北京)文化传播有限公司",
            "数字发行方": "网易云音乐",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_1.jpg"
        },
        {
            "作品名称": "C'mon in～",
            "表演者": "陈奕迅",
            "出品方": "EAS Music Limited",
            "制作人": "Jerald Chan",
            "实体发行方": "广东星外星文化传播有限公司",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_2.jpg"
        },
        {
            "作品名称": "伟大的渺小",
            "表演者": "林俊杰",
            "出品方": "亚洲华纳（北京）音乐娱乐咨询有限公司",
            "制作人": "林俊杰、许环良",
            "实体发行方": "经典五大(北京)文化传播有限公司",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_3.jpg"
        },
        {
            "作品名称": "心里学",
            "表演者": "徐佳莹",
            "出品方": "亚神音乐娱乐股份有限公司",
            "制作人": "陈建骐、陈君豪、Starr Chen",
            "实体发行方": "京东音像",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_4.jpg"
        },
        {
            "作品名称": "嗯",
            "表演者": "李荣浩",
            "出品方": "亚洲华纳（北京）音乐娱乐咨询有限公司",
            "制作人": "李荣浩",
            "实体发行方": "经典五大(北京)文化传播有限公司",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_5.jpg"
        }
    ],
    "年度歌曲": [
        {
            "作品名称": "猎户星座",
            "表演者": "朴树",
            "作曲": "朴树",
            "作词": "朴树",
            "出品方": "不晚音乐/地球娱乐",
            "制作人": "朴树、张亚东",
            "实体发行方": "经典五大(北京)文化传播有限公司",
            "数字发行方": "网易云音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_6.jpg"
        },
        {
            "作品名称": "说散就散",
            "表演者": "袁娅维",
            "作曲": "伍乐城",
            "作词": "张楚翘",
            "出品方": "亚洲华纳（北京）音乐娱乐咨询有限公司",
            "制作人": "伍乐城",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_7.jpg"
        },
        {
            "作品名称": "连名带姓",
            "表演者": "张惠妹",
            "作曲": "周杰伦",
            "作词": "葛大为",
            "出品方": "Mei Entertainment Ltd",
            "制作人": "小安",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_8.jpg"
        },
        {
            "作品名称": "匆匆2017",
            "表演者": "李剑青",
            "作曲": "李剑青",
            "作词": "李宗盛",
            "出品方": "相信音乐",
            "制作人": "李宗盛",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_9.jpg"
        },
        {
            "作品名称": "郭源潮",
            "表演者": "宋冬野",
            "作曲": "宋冬野",
            "作词": "宋冬野",
            "出品方": "北京摩登天空文化发展有限公司",
            "制作人": "宋冬野",
            "实体发行方": "中国科学文化音像出版社有限公司",
            "数字发行方": "全网",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_10.jpg"
        }
    ],
    "年度男歌手": [
        {
            "作品名称": "C'mon in~ （专辑）",
            "表演者": "陈奕迅",
            "出品方": "EAS Music Limited",
            "实体发行方": "广东星外星文化传播有限公司",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_11.jpg"
        },
        {
            "作品名称": "伟大的渺小 （专辑）",
            "表演者": "林俊杰",
            "出品方": "亚洲华纳（北京）音乐娱乐咨询有限公司",
            "实体发行方": "经典五大(北京)文化传播有限公司",
            "数字发行方": "腾讯音乐",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_12.jpg"
        },
        {
            "作品名称": "猎户星座 （专辑）",
            "表演者": "朴树",
            "出品方": "不晚音乐/地球娱乐",
            "实体发行方": "经典五大(北京)文化传播有限公司",
            "数字发行方": "网易云音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_13.jpg"
        },
        {
            "作品名称": "嗯 （专辑）",
            "表演者": "李荣浩",
            "出品方": "亚洲华纳（北京）音乐娱乐咨询有限公司",
            "实体发行方": "经典五大(北京)文化传播有限公司",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_14.jpg"
        },
        {
            "作品名称": "不明下落 （单曲）",
            "表演者": "郭顶",
            "出品方": "北京享耳音乐文化有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_15.jpg"
        }
    ],
    "年度女歌手": [
        {
            "作品名称": "说散就散 （单曲）",
            "表演者": "袁娅维",
            "出品方": "亚洲华纳（北京）音乐娱乐咨询有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_16.jpg"
        },
        {
            "作品名称": "松绑 （专辑）",
            "表演者": "丁薇",
            "出品方": "独立出品",
            "实体发行方": "区域内未发行",
            "数字发行方": "网易云音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_17.jpg"
        },
        {
            "作品名称": "偷故事的人 （专辑）",
            "表演者": "张惠妹",
            "出品方": "Mei Entertainment Ltd",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_18.jpg"
        },
        {
            "作品名称": "第13号作品：跳舞的梵谷 （专辑）",
            "表演者": "孙燕姿",
            "出品方": "Make Music Private Limited",
            "实体发行方": "广东星外星文化传播有限公司",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_19.jpg"
        },
        {
            "作品名称": "流行 （专辑）",
            "表演者": "李宇春",
            "出品方": "黄色石头",
            "实体发行方": "区域内未发行",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_20.jpg"
        }
    ],
    "年度组合/团体": [
        {
            "作品名称": "火星电台 （专辑）",
            "表演者": "火星电台",
            "出品方": "北京飞行者音乐科技有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "腾讯音乐",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_21.jpg"
        },
        {
            "作品名称": "生来倔强 （专辑）",
            "表演者": "南征北战",
            "出品方": "北京东亚星光文化传播有限公司",
            "实体发行方": "广东星外星文化传播有限公司",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_22.jpg"
        },
        {
            "作品名称": "镜花园 （专辑）",
            "表演者": "耀乐团",
            "出品方": "太合麦田（天津）音乐有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_23.jpg"
        },
        {
            "作品名称": "迷粤 （专辑）",
            "表演者": "新乐府",
            "出品方": "北京十三月文化传播有限公司",
            "实体发行方": "中国唱片上海公司",
            "数字发行方": "阿里音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_24.jpg"
        },
        {
            "作品名称": "有约 （单曲）",
            "表演者": "Twins",
            "出品方": "英皇娱乐",
            "实体发行方": "区域内未发行",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_25.jpg"
        }
    ],
    "年度乐队": [
        {
            "作品名称": "闪光的回忆 （单曲）",
            "表演者": "逃跑计划",
            "出品方": "北京东亚星光文化传播有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_26.jpg"
        },
        {
            "作品名称": "永远都会在 （专辑）",
            "表演者": "旅行团",
            "出品方": "北京中子街声文化发展有限公司",
            "实体发行方": "三辰影库音像出版社有限公司",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_27.jpg"
        },
        {
            "作品名称": "故乡 （专辑）",
            "表演者": "杭盖乐队",
            "出品方": "北京天浩盛世娱乐文化有限公司",
            "实体发行方": "广东星外星文化传播有限公司",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_28.jpg"
        },
        {
            "作品名称": "Replay （专辑）",
            "表演者": "狮子合唱团",
            "出品方": "亚洲华纳（北京）音乐娱乐咨询有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_29.jpg"
        },
        {
            "作品名称": "Before The Applause （专辑）",
            "表演者": "重塑雕像的权利",
            "出品方": "北京摩登天空文化发展有限公司",
            "实体发行方": "中国科学文化音像出版社有限公司",
            "数字发行方": "网易云音乐",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_30.jpg"
        }
    ],
    "年度新人": [
        {
            "作品名称": "21 （专辑）",
            "表演者": "VaVa",
            "出品方": "北京也是文化发展有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_31.jpg"
        },
        {
            "作品名称": "知非 （专辑）",
            "表演者": "谢春花",
            "出品方": "杭州心喜文化发展有限公司",
            "实体发行方": "北京电视艺术中心音像出版社有限公司",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_32.jpg"
        },
        {
            "作品名称": "深的深 （专辑）",
            "表演者": "周深",
            "出品方": "脸雾（北京）影视文化发展有限公司",
            "实体发行方": "九州音像出版公司",
            "数字发行方": "华宇世博音乐文化（北京）有限公司",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_33.jpg"
        },
        {
            "作品名称": "29 （单曲）",
            "表演者": "许钧",
            "出品方": "梦响当然音乐文化传播（上海）有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "腾讯音乐",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_34.jpg"
        },
        {
            "作品名称": "出云南记 （专辑）",
            "表演者": "Kawa",
            "出品方": "北京草台回声文化传播有限公司",
            "实体发行方": "京东音像",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_35.jpg"
        }
    ],
    "最佳流行专辑": [
        {
            "作品名称": "猎户星座",
            "表演者": "朴树",
            "出品方": "不晚音乐/地球娱乐",
            "制作人": "朴树、张亚东",
            "实体发行方": "经典五大(北京)文化传播有限公司",
            "数字发行方": "网易云音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_36.jpg"
        },
        {
            "作品名称": "嗯",
            "表演者": "李荣浩",
            "出品方": "亚洲华纳（北京）音乐娱乐咨询有限公司",
            "制作人": "李荣浩",
            "实体发行方": "经典五大(北京)文化传播有限公司",
            "数字发行方": "全网",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_37.jpg"
        },
        {
            "作品名称": "偷故事的人",
            "表演者": "张惠妹",
            "出品方": "Mei Entertainment Ltd",
            "制作人": "小安、aMEI",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_38.jpg"
        },
        {
            "作品名称": "松绑",
            "表演者": "丁薇",
            "出品方": "独立出品",
            "制作人": "林朝阳",
            "实体发行方": "区域内未发行",
            "数字发行方": "网易云音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_39.jpg"
        },
        {
            "作品名称": "第13号作品：跳舞的梵谷",
            "表演者": "孙燕姿",
            "出品方": "Make Music Private Limited",
            "制作人": "孙燕姿",
            "实体发行方": "广东星外星文化传播有限公司",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_40.jpg"
        }
    ],
    "最佳流行表演": [
        {
            "作品名称": "不明下落 （单曲）",
            "表演者": "郭顶",
            "出品方": "北京享耳音乐文化有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_41.jpg"
        },
        {
            "作品名称": "偷故事的人 （专辑）",
            "表演者": "张惠妹",
            "出品方": "Mei Entertainment Ltd",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_42.jpg"
        },
        {
            "作品名称": "松绑 （专辑）",
            "表演者": "丁薇",
            "出品方": "独立出品",
            "实体发行方": "区域内未发行",
            "数字发行方": "网易云音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_43.jpg"
        },
        {
            "作品名称": "流行 （专辑）",
            "表演者": "李宇春",
            "出品方": "黄色石头",
            "实体发行方": "区域内未发行",
            "数字发行方": "腾讯音乐",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_44.jpg"
        },
        {
            "作品名称": "C'mon in～ （专辑）",
            "表演者": "陈奕迅",
            "出品方": "EAS Music Limited",
            "实体发行方": "广东星外星文化传播有限公司",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_45.jpg"
        }
    ],
    "最佳摇滚专辑": [
        {
            "作品名称": "Before The Applause",
            "表演者": "重塑雕像的权利",
            "出品方": "北京摩登天空文化发展有限公司",
            "制作人": "Hector Castillo",
            "实体发行方": "中国科学文化音像出版社有限公司",
            "数字发行方": "网易云音乐",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_46.jpg"
        },
        {
            "作品名称": "摇滚交响音乐会",
            "表演者": "崔健",
            "出品方": "北京东西音乐艺术制作有限责任公司",
            "制作人": "崔健",
            "实体发行方": "中国科学文化音像出版社有限公司",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_47.jpg"
        },
        {
            "作品名称": "本色",
            "表演者": "黑豹乐队",
            "出品方": "上海风华秋实文化传媒有限公司",
            "制作人": "风华秋实文化传媒",
            "实体发行方": "广东星文文化传媒有限公司",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_48.jpg"
        },
        {
            "作品名称": "永远都会在",
            "表演者": "旅行团",
            "出品方": "北京中子街声文化发展有限公司",
            "制作人": "韦伟",
            "实体发行方": "三辰影库音像出版社有限公司",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_49.jpg"
        },
        {
            "作品名称": "无解俱乐部",
            "表演者": "马赛克",
            "出品方": "北京摩登天空文化发展有限公司",
            "制作人": "Wouter Vlaeminck",
            "实体发行方": "中国科学文化音像出版社有限公司",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_50.jpg"
        }
    ],
    "最佳摇滚表演": [
        {
            "作品名称": "闪光的回忆 （单曲）",
            "表演者": "逃跑计划",
            "出品方": "北京东亚星光文化传播有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_51.jpg"
        },
        {
            "作品名称": "本色（专辑）",
            "表演者": "黑豹乐队",
            "出品方": "上海风华秋实文化传媒有限公司",
            "实体发行方": "广东星文文化传媒有限公司",
            "数字发行方": "腾讯音乐",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_52.jpg"
        },
        {
            "作品名称": "29 （单曲）",
            "表演者": "许钧",
            "出品方": "梦响当然音乐文化传播（上海）有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_53.jpg"
        },
        {
            "作品名称": "那不是我 （专辑）",
            "表演者": "谢天笑",
            "出品方": "北京摩登天空文化发展有限公司",
            "实体发行方": "三辰影库音像出版社有限公司",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_54.jpg"
        },
        {
            "作品名称": "一往深情 （单曲）",
            "表演者": "梁博",
            "出品方": "北京少城时代文化发展有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_55.jpg"
        }
    ],
    "最佳当代民谣专辑": [
        {
            "作品名称": "知非",
            "表演者": "谢春花",
            "出品方": "杭州心喜文化发展有限公司",
            "制作人": "谢知非",
            "实体发行方": "北京电视艺术中心音像出版社有限公司",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_56.jpg"
        },
        {
            "作品名称": "赵照",
            "表演者": "赵照",
            "出品方": "上海风华秋实文化传媒有限公司",
            "制作人": "赵照音乐工作室",
            "实体发行方": "广东星文文化传媒有限公司",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_57.jpg"
        },
        {
            "作品名称": "一如年少模样",
            "表演者": "陈鸿宇",
            "出品方": "众乐纪",
            "制作人": "陈鸿宇",
            "实体发行方": "中国科学文化音像出版社有限公司",
            "数字发行方": "看见音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_58.jpg"
        },
        {
            "作品名称": "认真地老去",
            "表演者": "张希",
            "出品方": "北京易柏文化发展有限公司",
            "制作人": "张希",
            "实体发行方": "九州音像出版公司",
            "数字发行方": "网易云音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_59.jpg"
        },
        {
            "作品名称": "天秤之舟／牙齿，菠菜和豆腐与诗人，流浪汉和门徒",
            "表演者": "万晓利",
            "出品方": "独立出品",
            "制作人": "万晓利",
            "实体发行方": "北京电视艺术中心音像出版社有限公司",
            "数字发行方": "网易云音乐",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_60.jpg"
        }
    ],
    "最佳当代民谣表演": [
        {
            "作品名称": "赵照 （专辑）",
            "表演者": "赵照",
            "出品方": "上海风华秋实文化传媒有限公司",
            "实体发行方": "广东星文文化传媒有限公司",
            "数字发行方": "腾讯音乐",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_61.jpg"
        },
        {
            "作品名称": "死里复活 （单曲）",
            "表演者": "阿朵",
            "出品方": "生养之地（北京）文化传媒有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "网易云音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_62.jpg"
        },
        {
            "作品名称": "认真地老去 （专辑）",
            "表演者": "张希",
            "出品方": "北京易柏文化发展有限公司",
            "实体发行方": "九州音像出版公司",
            "数字发行方": "华宇世博音乐文化（北京）有限公司",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_63.jpg"
        },
        {
            "作品名称": "笃信 （单曲）",
            "表演者": "邵夷贝",
            "出品方": "上海香蕉计划演出经纪有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_64.jpg"
        },
        {
            "作品名称": "鱼里言吾 （专辑）",
            "表演者": "李雨",
            "出品方": "发声音乐",
            "实体发行方": "经典五大（北京）文化传播有限公司",
            "数字发行方": "阿里音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_65.jpg"
        }
    ],
    "最佳说唱专辑": [
        {
            "作品名称": "Vinida万妮达",
            "表演者": "万妮达",
            "出品方": "北京摩登天空文化发展有限公司",
            "制作人": "Yogurt、DJ Mustard",
            "实体发行方": "中国科学文化音像出版社有限公司",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_66.jpg"
        },
        {
            "作品名称": "差不多人生",
            "表演者": "陈奂仁",
            "出品方": "BBS Records Limited/地球娱乐",
            "制作人": "陈奂仁",
            "实体发行方": "区域内未发行",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_67.jpg"
        },
        {
            "作品名称": "KAFREEMAN",
            "表演者": "Kafe.Hu",
            "出品方": "北京摩登天空文化发展有限公司",
            "制作人": "Kafe.Hu",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_68.jpg"
        },
        {
            "作品名称": "21",
            "表演者": "VaVa",
            "出品方": "北京也是文化发展有限公司",
            "制作人": "Double_G、卡斯、王子",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_69.jpg"
        },
        {
            "作品名称": "搞砸",
            "表演者": "兄弟本色",
            "出品方": "滚石国际音乐股份有限公司",
            "制作人": "梯依恩",
            "实体发行方": "区域内未发行",
            "数字发行方": "阿里音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_70.jpg"
        }
    ],
    "最佳说唱表演": [
        {
            "作品名称": "你看得见 （单曲）",
            "表演者": "Jony J",
            "出品方": "Shooc",
            "实体发行方": "区域内未发行",
            "数字发行方": "网易云音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_71.jpg"
        },
        {
            "作品名称": "21 （专辑）",
            "表演者": "VaVa",
            "出品方": "北京也是文化发展有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_72.jpg"
        },
        {
            "作品名称": "火锅底料 （单曲）",
            "表演者": "GAI",
            "出品方": "北京大象无形音乐有限公司",
            "实体发行方": "广州市丁零文化传播有限公司",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_73.jpg"
        },
        {
            "作品名称": "搞砸 （专辑）",
            "表演者": "兄弟本色",
            "出品方": "滚石国际音乐股份有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "阿里音乐",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_74.jpg"
        },
        {
            "作品名称": "6 （单曲）",
            "表演者": "吴亦凡",
            "出品方": "北京凡世文化传媒有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_75.jpg"
        }
    ],
    "最佳民族/民间演奏专辑": [
        {
            "作品名称": "白山松水图",
            "表演者": "吉林省交响乐团民族管弦乐队、史志有（指挥）",
            "出品方": "库客音乐",
            "制作人": "库客音乐",
            "实体发行方": "中国科学文化音像出版社有限公司",
            "数字发行方": "库客音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_76.jpg"
        },
        {
            "作品名称": "指花风影",
            "表演者": "欢庆与李带菓",
            "出品方": "上海星外星文化传播有限公司",
            "制作人": "李带菓",
            "实体发行方": "广东星外星文化传播有限公司",
            "数字发行方": "阿里音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_77.jpg"
        },
        {
            "作品名称": "民乐大拜年",
            "表演者": "华夏民乐团（华夏民族乐团）",
            "出品方": "颂今音乐",
            "制作人": "吴颂今",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_78.jpg"
        },
        {
            "作品名称": "楚颂——孙凰二胡演奏专辑",
            "表演者": "孙凰",
            "出品方": "中国唱片总公司",
            "制作人": "侯钧",
            "实体发行方": "中国唱片（上海）有限公司",
            "数字发行方": "区域未发行",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_79.jpg"
        },
        {
            "作品名称": "指尖芭蕾——董晓琳琵琶演奏专辑",
            "表演者": "董晓琳",
            "出品方": "中国唱片总公司",
            "制作人": "侯钧",
            "实体发行方": "中国唱片（上海）有限公司",
            "数字发行方": "区域未发行",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_80.jpg"
        }
    ],
    "最佳民族/民间演唱专辑": [
        {
            "作品名称": "故乡",
            "表演者": "杭盖乐队",
            "出品方": "北京天浩盛世娱乐文化有限公司",
            "制作人": "Bob Ezrin、Justin Cortelyou、Rza Li",
            "实体发行方": "广东星外星文化传播有限公司",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_81.jpg"
        },
        {
            "作品名称": "迷粤",
            "表演者": "新乐府",
            "出品方": "北京十三月文化传播有限公司",
            "制作人": "鹤这豹脾气",
            "实体发行方": "中国唱片上海公司",
            "数字发行方": "阿里音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_82.jpg"
        },
        {
            "作品名称": "织谣II",
            "表演者": "斯琴格日乐",
            "出品方": "独立出品",
            "制作人": "斯琴格日乐",
            "实体发行方": "广东星外星文化传播有限公司",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_83.jpg"
        },
        {
            "作品名称": "出云南记",
            "表演者": "Kawa",
            "出品方": "北京草台回声文化传播有限公司",
            "制作人": "老黑",
            "实体发行方": "京东音像",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_84.jpg"
        },
        {
            "作品名称": "死里复活",
            "表演者": "阿朵",
            "出品方": "生养之地（北京）文化传媒有限公司",
            "制作人": "阿朵、陈伟伦 等",
            "实体发行方": "区域内未发行",
            "数字发行方": "华宇世博音乐文化（北京）有限公司",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_85.jpg"
        }
    ],
    "最佳电子器乐专辑": [
        {
            "作品名称": "Love Is Illusion",
            "表演者": "Joy Ginger",
            "出品方": "Babel Records",
            "制作人": "Joy Ginger",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_86.jpg"
        },
        {
            "作品名称": "嬉游",
            "表演者": "刘为",
            "出品方": "独立出品",
            "制作人": "刘为",
            "实体发行方": "广东星外星文化传播有限公司",
            "数字发行方": "阿里音乐",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_87.jpg"
        },
        {
            "作品名称": "回声图书馆",
            "表演者": "谢玉岗",
            "出品方": "Space Circle",
            "制作人": "谢玉岗",
            "实体发行方": "东方出版中心音像出版社\n",
            "数字发行方": "网易云、虾米音乐、腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_88.jpg"
        },
        {
            "作品名称": "昊漢",
            "表演者": "杨天光",
            "出品方": "独立出品",
            "制作人": "杨天光、TOBY MASON",
            "实体发行方": "区域内未发行",
            "数字发行方": "网易云音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_89.jpg"
        },
        {
            "作品名称": "奇迹寻踪",
            "表演者": "惘闻乐队",
            "出品方": "Space Circle ",
            "制作人": "惘闻乐队",
            "实体发行方": "东方出版中心音像出版社\n",
            "数字发行方": "网易云、虾米音乐、腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_90.jpg"
        }
    ],
    "最佳舞曲/电子演唱专辑": [
        {
            "作品名称": "火星电台",
            "表演者": "火星电台",
            "出品方": "北京飞行者音乐科技有限公司",
            "制作人": "火星电台",
            "实体发行方": "区域内未发行",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_91.jpg"
        },
        {
            "作品名称": "念思愁",
            "表演者": "陈伟伦",
            "出品方": "陈伟伦音乐工作室",
            "制作人": "陈伟伦",
            "实体发行方": "广东音像出版社有限公司",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_92.jpg"
        },
        {
            "作品名称": "镜花园",
            "表演者": "耀乐团",
            "出品方": "太合麦田（天津）音乐有限公司",
            "制作人": "王璐、冯宣元",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_93.jpg"
        },
        {
            "作品名称": "流行",
            "表演者": "李宇春",
            "出品方": "黄色石头",
            "制作人": "Justin Gray、谭伊哲、Zhu、陈伟伦、郑楠、Afshin Salmani、Josh Cumbee",
            "实体发行方": "区域内未发行",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_94.jpg"
        },
        {
            "作品名称": "谢谢你曾经让我悲伤",
            "表演者": "原子邦妮",
            "出品方": "滚石国际音乐股份有限公司",
            "制作人": "原子邦妮",
            "实体发行方": "区域内未发行",
            "数字发行方": "阿里音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_95.jpg"
        }
    ],
    "最佳爵士演奏专辑": [
        {
            "作品名称": "三棱镜",
            "表演者": "肖骏",
            "出品方": "JZmusic",
            "制作人": "肖骏",
            "实体发行方": "新汇集团上海声像出版社",
            "数字发行方": "腾讯音乐",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_96.jpg"
        },
        {
            "作品名称": "无常",
            "表演者": "TTechmak",
            "出品方": "JZmusic",
            "制作人": "Toby Mak",
            "实体发行方": "新汇集团上海声像出版社",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_97.jpg"
        },
        {
            "作品名称": "水晶紫",
            "表演者": "J3 Trio",
            "出品方": "JZmusic",
            "制作人": "黄健怡",
            "实体发行方": "新汇集团上海声像出版社",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_98.jpg"
        },
        {
            "作品名称": "花脸",
            "表演者": "金浩",
            "出品方": "地球娱乐",
            "制作人": "金浩",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_99.jpg"
        }
    ],
    "最佳爵士演唱专辑": [
        {
            "作品名称": "司徒先生",
            "表演者": "司徒嘉伟",
            "出品方": "独立出品",
            "制作人": "司徒嘉伟",
            "实体发行方": "广东星外星文化传播有限公司",
            "数字发行方": "阿里音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_100.jpg"
        }
    ],
    "最佳古典演绎专辑": [
        {
            "作品名称": "早春二月",
            "表演者": "江苏省交响乐团、程晔（指挥）",
            "出品方": "库客音乐",
            "制作人": "库客音乐",
            "实体发行方": "中国科学文化音像出版社有限公司",
            "数字发行方": "库客音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_101.jpg"
        },
        {
            "作品名称": "圣桑：小提琴和乐队作品",
            "表演者": "杨天娲（小提琴）、加布利尔·施瓦布（大提琴）、瑞典马尔默交响乐团、马克.苏斯特罗（指挥）",
            "出品方": "拿索斯中国",
            "制作人": "Sean Lewis",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_102.jpg"
        },
        {
            "作品名称": "上海之梦——莫扎特圆号作品集",
            "表演者": "韩小明（圆号）、芝加哥交响乐团（合作乐手）、萨尔布鲁克广播交响乐团（合作乐手）",
            "出品方": "拿索斯中国",
            "制作人": "Dieter Oehms",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_103.jpg"
        },
        {
            "作品名称": "无终",
            "表演者": "王燕（女高音）、天津交响乐团、易娟子（指挥）",
            "出品方": "库客音乐",
            "制作人": "库客音乐",
            "实体发行方": "中国科学文化音像出版社有限公司",
            "数字发行方": "库客音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_104.jpg"
        },
        {
            "作品名称": "林戈尔：印象",
            "表演者": "四川音乐学院交响乐团、朱其元（指挥）",
            "出品方": "库客音乐",
            "制作人": "库客音乐",
            "实体发行方": "中国科学文化音像出版社有限公司",
            "数字发行方": "库客音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_105.jpg"
        }
    ],
    "最佳古典原创专辑": [
        {
            "作品名称": "北极光",
            "表演者": "朱利安·施瓦茨（大提琴）、玛丽卡·波南柯（钢琴）",
            "作曲": "盛宗亮",
            "出品方": "拿索斯中国",
            "制作人": "Phil Rowlands",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_106.jpg"
        },
        {
            "作品名称": "小提琴、大提琴及唢呐协奏曲",
            "表演者": "黄蒙拉（小提琴）、秦立巍（大提琴）、张倩渊（唢呐）、维也纳广播交响乐团、戈特弗里德·拉博（指挥）",
            "作曲": "秦文琛",
            "出品方": "拿索斯中国",
            "制作人": "Erich Hofmann",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_107.jpg"
        },
        {
            "作品名称": "不在的你们都去了哪里",
            "表演者": "Cicada",
            "作曲": "Cicada",
            "出品方": "北京中子街声文化发展有限公司",
            "制作人": "江致洁",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_108.jpg"
        }
    ],
    "最佳影视原声音乐专辑": [
        {
            "作品名称": "《芳华》电影原声音乐",
            "表演者": "国际首席爱乐乐团",
            "作曲": "赵麟",
            "出品方": "浙江东阳美拉传媒有限公司",
            "制作人": "赵麟",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_109.jpg"
        },
        {
            "作品名称": "《夏至未至》 电视剧原声带",
            "表演者": "群星",
            "作曲": "﻿黄艾伦、翁玮盈、孙艺澄、汪苏泷、马敬、李全",
            "出品方": "北京听见时代娱乐传媒有限公司",
            "制作人": "黎偌天、胡皓、郑楠",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_110.jpg"
        },
        {
            "作品名称": "《欢乐颂2》电视剧原声带",
            "表演者": "群星",
            "作曲": "董冬冬",
            "出品方": "北京呆猫互娱文化传媒有限公司",
            "制作人": "董冬冬",
            "实体发行方": "区域内未发行",
            "数字发行方": "网易云音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_111.jpg"
        },
        {
            "作品名称": "《军师联盟》 电视剧原声带",
            "表演者": "董冬冬",
            "作曲": "董冬冬",
            "出品方": "北京呆猫互娱文化传媒有限公司",
            "制作人": "董冬冬",
            "实体发行方": "区域内未发行",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_112.jpg"
        },
        {
            "作品名称": "《醉玲珑》电视剧原声带",
            "表演者": "群星",
            "作曲": "金大洲、杜雯媞、胜屿、徐良、钱雷",
            "出品方": "北京听见时代娱乐传媒有限公司",
            "制作人": "黎偌天、任寒冰",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_113.jpg"
        }
    ],
    "最佳电子游戏原声音乐": [
        {
            "作品名称": "《ICEY》游戏原声",
            "表演者": "小旭音乐",
            "作曲": "小旭音乐团队",
            "出品方": "上海幻刃网络科技有限公司",
            "制作人": "卢小旭",
            "实体发行方": "区域内未发行",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_114.jpg"
        },
        {
            "作品名称": "《Loner》游戏原声带",
            "表演者": "曲锐",
            "作曲": "曲锐",
            "出品方": "成都蓝飞互娱科技有限公司",
            "制作人": "曲锐",
            "实体发行方": "区域内未发行",
            "数字发行方": "发现音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_115.jpg"
        },
        {
            "作品名称": "《魂斗罗》游戏原声",
            "表演者": "小旭音乐",
            "作曲": "小旭音乐团队",
            "出品方": "腾讯科技（深圳）有限公司",
            "制作人": "卢小旭",
            "实体发行方": "区域内未发行",
            "数字发行方": "腾讯音乐",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_116.jpg"
        },
        {
            "作品名称": "《德州扑克》游戏原声",
            "表演者": "小旭音乐",
            "作曲": "小旭音乐团队",
            "出品方": "小旭音乐",
            "制作人": "卢小旭",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_117.jpg"
        }
    ],
    "最佳儿童音乐专辑": [
        {
            "作品名称": "古诗童韵",
            "表演者": "群星",
            "作曲": "“古诗童韵”创作团队",
            "出品方": "北京成桥文化传播有限责任公司",
            "制作人": "赵麟",
            "实体发行方": "中国科学文化音像出版社有限公司",
            "数字发行方": "全网",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_118.jpg"
        },
        {
            "作品名称": "盛龙国学儿歌：二十四节气歌",
            "表演者": "马琦",
            "作曲": "宋毅",
            "出品方": "北京盛龙华艺影视传媒有限公司",
            "制作人": "慕音乐",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_119.jpg"
        }
    ],
    "最佳作词": [
        {
            "作品名称": "清白之年",
            "表演者": "朴树",
            "作词": "朴树",
            "出品方": "不晚音乐/地球娱乐",
            "实体发行方": "经典五大(北京)文化传播有限公司",
            "数字发行方": "网易云音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_120.jpg"
        },
        {
            "作品名称": "在家乡",
            "表演者": "李剑青",
            "作词": "李宗盛、严彬",
            "出品方": "街声/雀悦音乐/相信音乐",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_121.jpg"
        },
        {
            "作品名称": "出城",
            "表演者": "李剑青",
            "作词": "李宗盛、公路",
            "出品方": "街声/雀悦音乐/相信音乐",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_122.jpg"
        },
        {
            "作品名称": "宝贝 疯客",
            "表演者": "火星电台",
            "作词": "黄少峰@火星电台",
            "出品方": "飞行者音乐/街声",
            "实体发行方": "区域内未发行",
            "数字发行方": "网易云音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_123.jpg"
        },
        {
            "作品名称": "连名带姓",
            "表演者": "张惠妹",
            "作词": "葛大为",
            "出品方": "Mei Entertainment Ltd",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_124.jpg"
        }
    ],
    "最佳作曲": [
        {
            "作品名称": "匆匆2017",
            "表演者": "李剑青",
            "作曲": "李剑青",
            "出品方": "街声/雀悦音乐/相信音乐",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_125.jpg"
        },
        {
            "作品名称": "连名带姓",
            "表演者": "张惠妹",
            "作曲": "周杰伦",
            "出品方": "Mei Entertainment Ltd",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_126.jpg"
        },
        {
            "作品名称": "已来不及",
            "表演者": "丁薇",
            "作曲": "丁薇",
            "出品方": "独立出品",
            "实体发行方": "区域内未发行",
            "数字发行方": "网易云音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_127.jpg"
        },
        {
            "作品名称": "唱一首悲伤的歌 就当我为你送行了",
            "表演者": "赵照",
            "作曲": "赵照",
            "出品方": "上海风华秋实文化传媒有限公司",
            "实体发行方": "广东星文文化传媒有限公司",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_128.jpg"
        },
        {
            "作品名称": "歌谣",
            "表演者": "李荣浩",
            "作曲": "李荣浩",
            "出品方": "亚洲华纳（北京）音乐娱乐咨询有限公司",
            "实体发行方": "经典五大(北京)文化传播有限公司",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_129.jpg"
        }
    ],
    "最佳单曲制作（非古典）": [
        {
            "作品名称": "松绑",
            "表演者": "丁薇",
            "出品方": "独立出品",
            "制作人": "林朝阳",
            "实体发行方": "区域内未发行",
            "数字发行方": "网易云音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_130.jpg"
        },
        {
            "作品名称": "不明下落",
            "表演者": "郭顶",
            "出品方": "北京享耳音乐文化有限公司",
            "制作人": "郭顶",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_131.jpg"
        },
        {
            "作品名称": "匆匆2017",
            "表演者": "李剑青",
            "出品方": "街声/雀悦音乐/相信音乐",
            "制作人": "李宗盛",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_132.jpg"
        },
        {
            "作品名称": "嗜睡症",
            "表演者": "刘惜君",
            "出品方": "海蝶（天津）文化传播有限公司",
            "制作人": "郑楠",
            "实体发行方": "京东音像",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_133.jpg"
        },
        {
            "作品名称": "6",
            "表演者": "吴亦凡",
            "出品方": "北京凡世文化传媒有限公司",
            "制作人": "吴亦凡、Kevin Shin",
            "实体发行方": "区域内未发行",
            "数字发行方": "腾讯音乐",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_134.jpg"
        }
    ],
    "最佳专辑制作（非古典）": [
        {
            "作品名称": "猎户星座",
            "表演者": "朴树",
            "出品方": "不晚音乐/地球娱乐",
            "制作人": "朴树、张亚东",
            "实体发行方": "经典五大(北京)文化传播有限公司",
            "数字发行方": "网易云音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_135.jpg"
        },
        {
            "作品名称": "偷故事的人",
            "表演者": "张惠妹",
            "出品方": "Mei Entertainment Ltd",
            "制作人": "小安、aMEI",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_136.jpg"
        },
        {
            "作品名称": "C'mon in～",
            "表演者": "陈奕迅",
            "出品方": "EAS Music Limited",
            "制作人": "Jerald Chan",
            "实体发行方": "广东星外星文化传播有限公司",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_137.jpg"
        },
        {
            "作品名称": "松绑",
            "表演者": "丁薇",
            "出品方": "独立出品",
            "制作人": "林朝阳",
            "实体发行方": "区域内未发行",
            "数字发行方": "网易云音乐",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_138.jpg"
        },
        {
            "作品名称": "嗯",
            "表演者": "李荣浩",
            "出品方": "亚洲华纳（北京）音乐娱乐咨询有限公司",
            "制作人": "李荣浩",
            "实体发行方": "经典五大(北京)文化传播有限公司",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_139.jpg"
        }
    ],
    "最佳编曲": [
        {
            "作品名称": "火星电台 （专辑）",
            "表演者": "火星电台",
            "出品方": "北京飞行者音乐科技有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "腾讯音乐",
            "编曲": "曾宇@火星电台、DJ Mickey Zhang",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_140.jpg"
        },
        {
            "作品名称": "已来不及 （单曲）",
            "表演者": "丁薇",
            "出品方": "独立出品",
            "实体发行方": "区域内未发行",
            "数字发行方": "网易云音乐",
            "编曲": "林朝阳",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_141.jpg"
        },
        {
            "作品名称": "猎户星座 （单曲）",
            "表演者": "朴树",
            "出品方": "不晚音乐/地球娱乐",
            "实体发行方": "经典五大(北京)文化传播有限公司",
            "数字发行方": "网易云音乐",
            "编曲": "朴树",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_142.jpg"
        },
        {
            "作品名称": "嗯 （单曲）",
            "表演者": "李荣浩",
            "出品方": "亚洲华纳（北京）音乐娱乐咨询有限公司",
            "实体发行方": "经典五大(北京)文化传播有限公司",
            "数字发行方": "全网",
            "编曲": "李荣浩",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_143.jpg"
        },
        {
            "作品名称": "姥姥 （单曲）",
            "表演者": "李剑青",
            "出品方": "街声/雀悦音乐/相信音乐",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "编曲": "李剑青",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_144.jpg"
        }
    ],
    "最佳录音工程": [
        {
            "作品名称": "猎户星座 （单曲）",
            "表演者": "朴树",
            "出品方": "不晚音乐/地球娱乐",
            "实体发行方": "经典五大(北京)文化传播有限公司",
            "录音室": "Eastcoast（伦敦）、The Bridge（伦敦）、Megewave（北京）、家",
            "录音师": "卢楠、董泊宁",
            "数字发行方": "网易云音乐",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_145.jpg"
        },
        {
            "作品名称": "重来 （单曲）",
            "表演者": "丁薇",
            "出品方": "独立出品",
            "实体发行方": "区域内未发行",
            "录音室": "CRC Shibei Studio（北京）、Perfect Studio（北京)",
            "录音师": "张小安、老虎",
            "数字发行方": "网易云音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_146.jpg"
        },
        {
            "作品名称": "火星电台 Live at Blue Note Beijing （专辑）",
            "表演者": "火星电台",
            "出品方": "北京飞行者音乐科技有限公司",
            "实体发行方": "区域内未发行",
            "录音室": "Blue Note Beijing（现场）",
            "录音师": "杨启明",
            "数字发行方": "网易云音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_147.jpg"
        },
        {
            "作品名称": "不明下落 （单曲）",
            "表演者": "郭顶",
            "出品方": "北京享耳音乐文化有限公司",
            "实体发行方": "区域内未发行",
            "录音室": "MegaWave（北京）",
            "录音师": "卢楠、郭顶",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_148.jpg"
        },
        {
            "作品名称": "故乡 （专辑）",
            "表演者": "杭盖乐队",
            "出品方": "北京天浩盛世娱乐文化有限公司",
            "实体发行方": "广东星外星文化传播有限公司",
            "录音室": "The Tracking Room（纳什维尔）",
            "录音师": "Justin Cortelyou、Bryce Robertson、Rza Li",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_149.jpg"
        }
    ],
    "最佳混音工程": [
        {
            "作品名称": "猎户星座 （单曲）",
            "表演者": "朴树",
            "出品方": "不晚音乐/地球娱乐",
            "实体发行方": "经典五大(北京)文化传播有限公司",
            "数字发行方": "网易云音乐",
            "混音室": "Megewave（北京）/ Jet Studio（北京）",
            "混音师": "卢楠",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_150.jpg"
        },
        {
            "作品名称": "不明下落 （单曲）",
            "表演者": "郭顶",
            "出品方": "北京享耳音乐文化有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "混音室": "MegaWave（北京）",
            "混音师": "卢楠",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_151.jpg"
        },
        {
            "作品名称": "松绑 （单曲）",
            "表演者": "丁薇",
            "出品方": "独立出品",
            "实体发行方": "区域内未发行",
            "数字发行方": "网易云音乐",
            "混音室": "Metropolis Studios（伦敦）",
            "混音师": "Chris Brown",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_152.jpg"
        },
        {
            "作品名称": "Dear Friend （单曲）",
            "表演者": "袁娅维",
            "出品方": "亚洲华纳（北京）音乐娱乐咨询有限公司",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "混音室": "Tweak Tone Labs",
            "混音师": "周天澈",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_153.jpg"
        },
        {
            "作品名称": "故乡 （专辑）",
            "表演者": "杭盖乐队",
            "出品方": "北京天浩盛世娱乐文化有限公司",
            "实体发行方": "广东星外星文化传播有限公司",
            "数字发行方": "腾讯音乐",
            "混音室": "Anarchy Studios（纳什维尔）",
            "混音师": "Bob Ezrin、Justin Cortelyou",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_154.jpg"
        }
    ],
    "最佳视觉设计": [
        {
            "作品名称": "流行 （专辑）",
            "表演者": "李宇春",
            "出品方": "黄色石头",
            "实体发行方": "区域内未发行",
            "数字发行方": "腾讯音乐",
            "视觉设计师": "Vicson",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_155.jpg"
        },
        {
            "作品名称": "Before The Applause （专辑）",
            "表演者": "重塑雕像的权利",
            "出品方": "北京摩登天空文化发展有限公司",
            "实体发行方": "中国科学文化音像出版社有限公司",
            "数字发行方": "网易云音乐",
            "视觉设计师": "钱骞",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_156.jpg"
        },
        {
            "作品名称": "松绑 （专辑）",
            "表演者": "丁薇",
            "出品方": "独立出品",
            "实体发行方": "区域内未发行",
            "数字发行方": "网易云音乐",
            "视觉设计师": "Rose Lawrence",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_157.jpg"
        },
        {
            "作品名称": "偷故事的人 （专辑）",
            "表演者": "张惠妹",
            "出品方": "Mei Entertainment Ltd",
            "实体发行方": "区域内未发行",
            "数字发行方": "全网",
            "视觉设计师": "王志弘",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_158.jpg"
        },
        {
            "作品名称": "A.I. 愛 （专辑）",
            "表演者": "王力宏",
            "出品方": "宏声文化有限公司",
            "实体发行方": "正东音像制品贸易（上海）有限公司",
            "数字发行方": "腾讯音乐",
            "视觉设计师": "李仲强",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_159.jpg"
        }
    ],
    "最佳音乐录影带": [
        {
            "作品名称": "偷故事的人",
            "表演者": "张惠妹",
            "出品方": "Mei Entertainment Ltd",
            "录影带导演": "黄子然",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_160.jpg"
        },
        {
            "作品名称": "风衣",
            "表演者": "孙燕姿",
            "出品方": "Make Music Private Limited",
            "录影带导演": "邱柏昶",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_161.jpg"
        },
        {
            "作品名称": "出城",
            "表演者": "李剑青",
            "出品方": "相信音乐",
            "录影带导演": "董敏",
            "数字发行方": "微博秒拍",
            "是否获奖": true,
            "url": "http://img01.cmicawards.org.cn/cover/2018_162.jpg"
        },
        {
            "作品名称": "猎户星座",
            "表演者": "朴树",
            "出品方": "不晚音乐/地球娱乐",
            "录影带导演": "董小树",
            "数字发行方": "全网",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_163.jpg"
        },
        {
            "作品名称": "致观音山",
            "表演者": "罗大佑",
            "出品方": "大佑音乐",
            "录影带导演": "萧雅全",
            "数字发行方": "腾讯音乐",
            "是否获奖": false,
            "url": "http://img01.cmicawards.org.cn/cover/2018_164.jpg"
        }
    ]
}

export default data